import React, {useState, useEffect, useRef} from 'react'
import RowLayout from '../../../Layouts/RowLayout';
import SMCTextInput from '../../../Simple/SMCTextInput';
import Api from '../../../../api/SMPFetchHelper';
import {ObjectTypes} from '../../../../api/consts';
import {useTranslation} from 'react-i18next';
import AppTheme from '../../../../conf/AppTheme';
import { Portal} from '@mui/material';
import {makeStyles} from '@mui/styles'
import GlobalGatewaySearchItem from './GlobalGatewaySearchItem';
import {useBoolean} from '../../../../utils/hooks';

function GlobalGatewaySearch({
    currentPortal
}) 
{
    const { t } = useTranslation();
    const classes = useStyles();

    const [showResultsWindow, openResultsWindow, closeResultsWindow] = useBoolean(false);
    const [searchText, setSearchText] = useState('');
    const [gatewayResults, setGatewayResults] = useState([]);
    
    const ref = useRef(null);

    useEffect(() => {
        (async () => {
            if (!searchText) {
                setGatewayResults([]);
            } else {
                try {
                   
                    const searchGatewaysRes = await Api.fetchObjectListFromDomains(ObjectTypes.GATEWAY, 0, 10, null, null, {freeTextSearch: { value: searchText }});
                    const searchGatewaysResData = searchGatewaysRes.data;
                    const gatewayResultsBuilder = [];
                    searchGatewaysResData.data.forEach(res => {
                        gatewayResultsBuilder.push(res);
                    });
                    
                    setGatewayResults(gatewayResultsBuilder);
                 
                } catch (e) {
                    setGatewayResults([]);
                }
            }
        })();
    }, [searchText]);

    const SearchField = (
        <RowLayout className={classes.searchRoot}>
            <SMCTextInput
                value={searchText}
                onKeyDown={e => {
                        if (e.keyCode === 27) {
                            ref.current.blur();
                        }
                    }
                }
                onChange={e => setSearchText(e.target.value)}
                className={classes.searchTextInput}
                placeholder={t('SMC_GATEWAYWIZ_SEARCH_HEAD')}
                onFocus={openResultsWindow}
                onBlur={closeResultsWindow}
                suffixIcon="search"
                allowClearAll
                innerRef={ref}
            />
        </RowLayout>
    );

    const ResultsWindow = (
        <div className={classes.resultsWindowRoot}>
            {
                searchText === '' &&
                (
                    <div className={classes.searchPromptWindow}>
                        <div className={classes.searchPromptText}>
                            Search by gateway name, owner, plan, MAC, IP address, description or custom fields if in use.
                        </div>
                    </div>
                )
            }
            {
                gatewayResults.map((res, index) => <GlobalGatewaySearchItem key={index} gateway={res} searchText={searchText} onClick={() => ref.current.blur()} currentPortal={currentPortal} /> )
            }
        </div>
    );

    return (
        <>
            { SearchField }
            <Portal>
                <div style={{ visibility: showResultsWindow ? '' : "hidden" }}>
                    { ResultsWindow }
                </div>
            </Portal>
        </>
    );
}

const useStyles = makeStyles({
    searchRoot: {
        width: 275,
        height: 30,
        background: '#fff',
    },
    searchTextInput: {
        paddingLeft: '5px',
        width: 275,
        height: '100%',
        border: 'none',
        '&:focus': {
            border: 'none'
        }
    },
    resultsWindowRoot: {
        position: 'absolute',
        zIndex: AppTheme.zIndexes.globalSearch,
        fontSize: '13px',
        background: '#fff',
        border: '1px solid #ccc',
        width: 315,
        top: 39,
        right: 7,
    },
    searchPromptWindow: {
        height: '60px',
    },
    searchPromptText: {
        margin: 10
    }
});

export default GlobalGatewaySearch;